import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchContentViewPlansInCurrentBoard(pointSystemIdParam = null) {
  let pointSystemId = pointSystemIdParam;

  if (!pointSystemId) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (!pointSystem) {
      return;
    }
    pointSystemId = pointSystem.id;
  }

  yield put(actions.fetchContentViewPlans(pointSystemId));

  let body;
  try {
    body = yield call(request, api.getContentViewPlans, pointSystemId);
  } catch (error) {
    yield put(actions.fetchContentViewPlans.failure(pointSystemId, error));
    return;
  }

  yield put(actions.fetchContentViewPlans.success(pointSystemId, body.items));
}

export function* getOrCreateContentViewPlanInCurrentBoard(year, month, pointSystemIdParam = null) {
  let pointSystemId = pointSystemIdParam;

  if (!pointSystemId) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (!pointSystem) {
      return;
    }
    pointSystemId = pointSystem.id;
  }

  const data = { year, month };

  yield put(actions.getOrCreateContentViewPlan(pointSystemId, data));

  let item;
  try {
    ({ item } = yield call(request, api.getOrCreateContentViewPlan, pointSystemId, data));
  } catch (error) {
    yield put(actions.getOrCreateContentViewPlan.failure(pointSystemId, error));
    return;
  }

  yield put(actions.getOrCreateContentViewPlan.success(item));
}

export function* updateContentViewPlan(id, data) {
  yield put(actions.updateContentViewPlan(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateContentViewPlan, id, data));
  } catch (error) {
    yield put(actions.updateContentViewPlan.failure(id, error));
    return;
  }

  yield put(actions.updateContentViewPlan.success(item));
}

export default {
  fetchContentViewPlansInCurrentBoard,
  getOrCreateContentViewPlanInCurrentBoard,
  updateContentViewPlan,
};

